<template>

    <div>
        <vs-sidebar
            click-not-close
            position-right
            spacer
            parent="body"
            color="primary"
            default-index="1"
            class="new-chat-flows-promotions-sidebar items-no-padding"
            v-model="sidebarIsActive"
        >
        
            <div class="mt-6 flex items-center justify-between px-6">
                <h4> {{ context === 'update' ? 'ATUALIZAR' : 'CRIAR' }} PRODUTO </h4>
                <feather-icon
                    icon="XIcon"
                    @click.stop="sidebarIsActive = false"
                    class="cursor-pointer"
                />
            </div>

            <vs-divider class="mb-0"/>


            <div class="mt-10 ml-4 w-11/12">
                <span class="ml-1 text-sm"> Produto </span>
                <vs-input class="w-full" v-model="productName"/>
            </div>
                
            <div class="d-flex justify-left mt-6 ml-1">

                <div class="input-div-promotions-sidebar ml-3">
                    <span class="ml-8 text-sm"> Valor original </span>

                    <div class="d-flex items-center">
                        <span class="p-0 pr-1">R$</span>
                        <vs-input
                            class="w-full"
                            v-model="price"
                            v-mask=" ['#.##','##.##','###.##','####.##','#####.##','######.##',]" 
                        />
                    </div>
                </div>

                <div class="input-div-promotions-sidebar ml-3">
                    <span class="ml-8 text-sm"> Valor promocional </span>

                    <div class="d-flex items-center">
                        <span class="p-0 pr-1">R$</span>
                        <vs-input
                            class="w-full"
                            v-model="discountPrice"
                            v-mask=" ['#.##','##.##','###.##','####.##','#####.##','######.##',]" 
                        />
                    </div>
                </div>

            </div>

            <div class="flex flex-wrap items-center p-6" slot="footer">

                <vs-button class="mr-6" @click.stop="context === 'create' ? create() : update()" :disabled="
                    (
                        (

                            price === null             ||
                            price === ''               ||
                            discountPrice === null     ||
                            discountPrice === ''       ||
                            productName.length === 0   ||
                            productName.trim() === ''  ||
                            productName.length >= 201
                        ) &&
                        context === 'create'
                    )
                "
                >
                    Salvar
                </vs-button>

                <vs-button type="border" color="danger" @click.stop="sidebarIsActive = false">
                    Cancelar
                </vs-button>

            </div>
    
        </vs-sidebar>
    </div>

</template>

<script>

    export default {
        name: 'PromotionsSidebar',
        data() {
            return {
                productName: '',
                price: 0.0,
                discountPrice: 0.0
            }
        },
        methods: {
            async create() {
                const price         = parseFloat(this.price);
                const discountPrice = parseFloat(this.discountPrice);

                if (!price || !discountPrice) {
                    return this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Você precisa adicionar os valores do preço e desconto!',
                            time: 5000
                        }
                    );
                }

                await this.$store.dispatch("prompt/create",
                    {
                        key: '{promotions}',
                        name: this.productName,
                        prompt_id: 1,
                        department_id: null,
                        price: price,
                        discount_price: discountPrice
                    }
                )
                .then( () => {
                    this.$emit('reloadQuery');
                    this.sidebarIsActive = false;
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'O produto da promoção foi criado com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao criar o produto da promoção!',
                            time: 5000
                        }
                    );
                });
            },
            async update() {
                await this.$store.dispatch("prompt/update",
                    {
                        id: this.data.id,
                        name: this.productName,
                        department_id: null,
                        is_active: null,
                        price: parseFloat(this.price),
                        discount_price: parseFloat(this.discountPrice)
                    }
                )
                .then( () => {
                    this.sidebarIsActive = false
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'A Segmentação foi atualizada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao atualizar a Segmentação!',
                            time: 5000
                        }
                    );
                });                
            }
        },
        computed: {
            sidebarIsActive: {
                get() {
                    return this.isActive;
                },
                set( value ) {
                    if ( !value ) {
                        this.$emit('isActiveFalse');
                    }
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true,
                default: false
            },
            context: {
                type: String,
                required: true,
                default: 'create'
            },
            data: {
                type: Object,
                required: false,
                default: {
                    id: null,
                    key: null,
                    name: null,
                    price: 0.0,
                    prompt_id: null,
                    discont_price: 0.0
                }
            }
        },
        watch: {
            isActive( value ) {
                if ( value && this.context === 'create' ) {
                    this.productName   = '';
                    this.price         = 0.0;
                    this.discountPrice = 0.0;
                }

                if ( value && this.context === 'update' ) {
                    this.productName   = this.data.name             || '';
                    this.price         = this.data.price            || 0.0;
                    this.discountPrice = this.data.discount_price   || 0.0;
                }
            },
            productName( value ) {
                if ( value && value.length === 201 ) {
                    this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Número máximo de caracteres atingido no nome do produto!',
                            time: 5000
                        }
                    );
                }
            }
        },
        emits: [
            'isActiveFalse',
            'reloadQuery'
        ]
    }

</script>

<style lang="scss" scoped>

    .new-chat-flows-promotions-sidebar {

        .input-div-promotions-sidebar {
            width: 170px;
        }
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;
        }

    }

</style>